<div *ngIf="nominatim" class="d-flex py-4 px-3">
  <div class="d-flex justify-content-center align-items-center" style="width: 32px; height: 32px">
    <sb-icon class="icon-in-btn" icon="search"></sb-icon>
  </div>
  <input
    (ngModelChange)="search($event)"
    [(ngModel)]="searchStr" class="form-control"
    placeholder="{{ 'lang.globals.searchPlaceholder' | translate }}">
</div>

<div [style.opacity]="opacity">
  <div class="mapbox">
    <div
      (leafletDrawReady)="onDrawReady($event)"
      (leafletMapMoveEnd)="emitMapMoveEnd()"
      (leafletMapReady)="onMapReady($event)"
      (leafletMapZoomEnd)="emitMapZoomEnd()"
      [leafletDrawOptions]="leafletDrawOptions"
      [leafletLayers]="internalLayers"
      [leafletOptions]="leafletOptions"
      [ngClass]="roundedCorners ? 'roundcorners' : ''"
      [ngStyle]="{'height': mHeight, 'width': mWidth ? mWidth : '100%'}"
      leaflet
      leafletCtrlToZoom
      leafletDraw
    >
    </div>
    <ng-container *ngIf="whatIsHere">
      <div [style.bottom.px]="dropdownBottom"
           [style.display]="dropdownDisplay"
           [style.left.px]="dropdownLeft"
           [style.right.px]="dropdownRight"
           [style.top.px]="dropdownTop"
           class="mapdropdown overlay"
      >
        <ng-scrollbar class="scrollDropdownDeviceOptions">
          <hr>
          <ng-container *ngFor="let option of options()">
            <button (click)="callDropdownAction(option.action)" [disabled]="!option.enabled" class="btn btn-hover-primary"
                    type="button">
              <sb-icon [icon]="option.icon" class="mr-3 icon-in-btn"></sb-icon>
              <b [style.color]="option.enabled ? '#000' : '#999'">{{option.text}}</b>
            </button>
            <hr>
          </ng-container>
        </ng-scrollbar>
      </div>
    </ng-container>
    <div *ngIf="zoomControl" class="overlay controls">
      <div class="btn-group-vertical">
        <button (click)="zoomIn()" class="btn btn-light" container="body" ngbTooltip="{{'lang.globals.map.zoomIn' | translate}}"
                placement="right" type="button">
          <sb-icon icon="plus"></sb-icon>
        </button>
        <button (click)="zoomOut()" class="btn btn-light" container="body" ngbTooltip="{{'lang.globals.map.zoomOut' | translate}}"
                placement="right" type="button">
          <sb-icon icon="minus"></sb-icon>
        </button>
        <button (click)="fitAreaBounds()" class="btn btn-light" container="body" ngbTooltip="{{'lang.globals.map.fitZoom' | translate}}"
                placement="right" type="button">
          <sb-icon icon="expand"></sb-icon>
        </button>
      </div>
    </div>
    <div *ngIf="showHelp && !readOnly" class="overlay help">
      <div class="row">
        <div class="col">
          <ng-container *ngIf="drawMode === 'DELETE'; else helpElse">
            <div *ngIf="showActiveModeInHelp" class="row justify-content-right">
              <div class="col d-flex justify-content-right text-end">
                <div class="text-end w-100">
                  <b class="danger">{{'lang.map.deleteMode'|translate}}</b>
                </div>
              </div>
            </div>
            <div class="row justify-content-right">
              <div class="col d-flex justify-content-right text-end">
                <div class="text-end w-100">
                  <b>{{'lang.map.deleteClick'|translate}}</b>
                </div>
              </div>
            </div>
          </ng-container>
          <ng-template #helpElse>
            <ng-container *ngIf="drawMode === 'DRAW'">
              <div *ngIf="showActiveModeInHelp" class="row justify-content-right">
                <div class="col d-flex justify-content-right text-end">
                  <div class="text-end w-100">
                    <b class="success">{{'lang.map.drawMode'|translate}}</b>
                  </div>
                </div>
              </div>
              <div *ngIf="isDrawToolActive()" class="row">
                <div class="col">
                  <div class="text-end w-100">
                    <ng-container
                      *ngIf="getCurrentDrawToolName()===('lang.globals.map.polygon'|translate) || getCurrentDrawToolName()===('lang.globals.map.line'|translate); else helpelse">
                      <div *ngIf="getCurrentDrawToolName()===('lang.globals.map.polygon'|translate)"
                           class="row justify-content-right">
                        <div class="col d-flex justify-content-right text-end">
                          <div class="text-end w-100">
                            <b>{{'lang.map.clickPolygon'|translate}}</b>
                          </div>
                        </div>
                      </div>
                      <div *ngIf="getCurrentDrawToolName()===('lang.globals.map.polygon'|translate)"
                           class="row justify-content-right">
                        <div class="col d-flex justify-content-right text-end">
                          <div class="text-end w-100">
                            <b>{{'lang.map.clickFinishPolygon'|translate}}</b>
                          </div>
                        </div>
                      </div>
                      <div *ngIf="getCurrentDrawToolName()===('lang.globals.map.line' |translate)"
                           class="row justify-content-right">
                        <div class="col d-flex justify-content-right text-end">
                          <div class="text-end w-100">
                            <b>{{'lang.map.clickLine'|translate}}</b>
                          </div>
                        </div>
                      </div>
                      <div *ngIf="getCurrentDrawToolName()===('lang.globals.map.line'|translate)"
                           class="row justify-content-right">
                        <div class="col d-flex justify-content-right text-end">
                          <div class="text-end w-100">
                            <b>{{'lang.map.clickFinishLine'|translate}}</b>
                          </div>
                        </div>
                      </div>
                    </ng-container>
                    <ng-template #helpelse>
                      <div class="row justify-content-right">
                        <div class="col d-flex justify-content-right text-end">
                          <div class="text-end w-100">
                            <ng-container *ngIf="getCurrentDrawToolName()===('lang.globals.map.rectangle'|translate)">
                              <b>{{'lang.map.clickRectangle'|translate}}</b>
                            </ng-container>
                            <ng-container *ngIf="getCurrentDrawToolName()===('lang.globals.map.circle'|translate)">
                              <b>{{'lang.map.clickCircle'|translate}}</b>
                            </ng-container>
                            <ng-container *ngIf="getCurrentDrawToolName()===('lang.globals.map.position'|translate)">
                              <b>{{'lang.map.clickPosition'|translate}}</b>
                            </ng-container>
                          </div>
                        </div>
                      </div>
                    </ng-template>
                  </div>
                </div>
              </div>
              <div *ngIf="!isDrawToolActive()" class="row justify-content-right">
                <div class="col d-flex justify-content-right text-end">
                  <div class="text-end w-100">
                    <b>{{'lang.map.toolSelection'|translate}}</b>
                  </div>
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="drawMode === 'CUT'">
              <div *ngIf="showActiveModeInHelp" class="row justify-content-right">
                <div class="col d-flex justify-content-right text-end">
                  <div class="text-end w-100">
                    <b class="warning">{{'lang.map.cutMode'|translate}}</b>
                  </div>
                </div>
              </div>
              <div *ngIf="isDrawToolActive()" class="row">
                <div class="col">
                  <div class="text-end w-100">
                    <ng-container *ngIf="getCurrentDrawToolName()=== ('lang.globals.map.polygon'|translate)">
                      <div class="row justify-content-right">
                        <div class="col d-flex justify-content-right text-end">
                          <div class="text-end w-100">
                            <b>{{'lang.map.cutPolygon'|translate}}</b>
                          </div>
                        </div>
                      </div>
                      <div class="row justify-content-right">
                        <div class="col d-flex justify-content-right text-end">
                          <div class="text-end w-100">
                            <b>{{'lang.map.clickFinishPolygon'|translate}}</b>
                          </div>
                        </div>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="getCurrentDrawToolName()=== ('lang.globals.map.rectangle'|translate)">
                      <div class="row justify-content-right">
                        <div class="col d-flex justify-content-right text-end">
                          <div class="text-end w-100">
                            <b>{{'lang.map.cutRectangle'|translate}}</b>
                          </div>
                        </div>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="getCurrentDrawToolName()===('lang.globals.map.circle'|translate)">
                      <div class="row justify-content-right">
                        <div class="col d-flex justify-content-right text-end">
                          <div class="text-end w-100">
                            <b>{{'lang.map.cutCircle'|translate}}</b>
                          </div>
                        </div>
                      </div>
                    </ng-container>
                  </div>
                </div>
              </div>
              <div *ngIf="!isDrawToolActive()" class="row justify-content-right">
                <div class="col d-flex justify-content-right text-end">
                  <div class="text-end w-100">
                    <b>{{'lang.map.toolCutSelection'|translate}}</b>
                  </div>
                </div>
              </div>
            </ng-container>
          </ng-template>
        </div>
      </div>
    </div>
    <div *ngIf="!readOnly" class="overlay menu">
      <div class="row">
        <div class="col-lg-12 col-xl-6">
          <div class="row">
            <div class="col d-flex justify-content-left text-start">
              <div class="btn-group">
                <button (click)="setDrawMode()" [ngClass]="getModeButtonClass('DRAW')"
                        container="body" ngbTooltip="{{'lang.globals.map.drawMode' | translate}}" placement="top">
                  <sb-icon icon="pen"></sb-icon>
                </button>
                <button (click)="setCutMode();" [ngClass]="getModeButtonClass('CUT')"
                        container="body" ngbTooltip="{{'lang.globals.map.cutMode' | translate}}" placement="top">
                  <sb-icon icon="scissors"></sb-icon>
                </button>
                <button (click)="setDeleteMode();" [ngClass]="getModeButtonClass('DELETE')"
                        container="body" ngbTooltip="{{'lang.globals.map.deleteMode' | translate}}"
                        placement="top">
                  <sb-icon icon="trash"></sb-icon>
                </button>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <div class="d-flex justify-content-left text-start">
                <ng-container *ngIf="drawMode === 'DRAW'">
                  <div>
                    <b class="success">{{'lang.map.drawMode'|translate}}</b>
                  </div>
                </ng-container>
                <ng-container *ngIf="drawMode === 'CUT'">
                  <div>
                    <b class="warning">{{'lang.map.cutMode'|translate}}</b>
                  </div>
                </ng-container>
                <ng-container *ngIf="drawMode === 'DELETE'">
                  <div>
                    <b class="danger">{{'lang.map.deleteMode'|translate}}</b>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-12 col-xl-6">
          <div class="row">
            <div class="col">
              <div [ngClass]="(isSmall ? 'justify-content-left text-start' : 'justify-content-right text-end')"
                   class="d-flex">
                <div class="btn-group mr-3">
                  <button (click)="toggleDrawPolygon()"
                          [ngClass]="getDrawButtonClass('polygon')" [placement]="isSmall ? 'bottom' : 'top'"
                          container="body" ngbTooltip="{{'lang.globals.map.polygon' | translate}}">
                    <sb-icon icon="polygon"></sb-icon>
                  </button>
                  <button (click)="toggleDrawRectangle()"
                          [ngClass]="getDrawButtonClass('rectangle')" [placement]="isSmall ? 'bottom' : 'top'"
                          container="body" ngbTooltip="{{'lang.globals.map.rectangle' | translate}}">
                    <sb-icon icon="boxFilled"></sb-icon>
                  </button>
                  <button (click)="toggleDrawCircle()"
                          [ngClass]="getDrawButtonClass('circle')" [placement]="isSmall ? 'bottom' : 'top'"
                          container="body" ngbTooltip="{{'lang.globals.map.circle' | translate}}">
                    <sb-icon icon="circleFilled"></sb-icon>
                  </button>
                </div>
                <div class="btn-group">
                  <button (click)="toggleDrawLineString()" [ngClass]="getDrawButtonClass('linestring')"
                          [placement]="isSmall ? 'bottom' : 'top'" container="body"
                          ngbTooltip="{{'lang.globals.map.line' | translate}}">
                    <sb-icon icon="lineMarkerArrow"></sb-icon>
                  </button>
                  <button (click)="toggleDrawPosition()" [ngClass]="getDrawButtonClass('position')"
                          [placement]="isSmall ? 'bottom' : 'top'"
                          container="body" ngbTooltip="{{'lang.globals.map.position' | translate}}">
                    <sb-icon icon="locationMarker"></sb-icon>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <div [ngClass]="(isSmall ? 'justify-content-left text-start' : 'justify-content-right text-end')"
                   class="d-flex">
                <div [ngClass]="(isSmall ? 'text-start' : 'text-end')" class="w-100">
                  <b
                    [ngClass]="getCurrentDrawToolClass()">{{getCurrentDrawToolName()}} {{'lang.map.toolSelected'|translate}}</b>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
